// client/src/context/LocalizationContext.jsx

import React from 'react';
import { useQuery } from '@tanstack/react-query';
import { fetchLocationData } from '../services/location.service';
import { fetchExchangeRates } from '../services/currency.service';
import { LocalizationContext } from '../hooks/useLocalization';

export const LocalizationProvider = ({ children }) => {
  const { data: locationData, isLoading: isLoadingLocation } = useQuery({
    queryKey: ['location'],
    queryFn: fetchLocationData,
    staleTime: 24 * 60 * 60 * 1000,
    refetchOnWindowFocus: false,
  });

  const { data: exchangeRates, isLoading: isLoadingRates } = useQuery({
    queryKey: ['exchangeRates'],
    queryFn: fetchExchangeRates,
    staleTime: 6 * 60 * 60 * 1000,
    refetchOnWindowFocus: false,
  });

  const isLoading = isLoadingLocation || isLoadingRates;

  const value = {
    locationData,
    exchangeRates,
    isLoading,
  };

  // No renderiza a los hijos hasta que sus datos estén listos.
  return (
    <LocalizationContext.Provider value={value}>
      {!isLoading ? children : null}
    </LocalizationContext.Provider>
  );
};
